export default "__VITE_ASSET__DIpxpUx$__"